import { render, staticRenderFns } from "./ProfileNav.vue?vue&type=template&id=7d585794&lang=pug&"
import script from "./ProfileNav.vue?vue&type=script&lang=js&"
export * from "./ProfileNav.vue?vue&type=script&lang=js&"
import style0 from "./ProfileNav.vue?vue&type=style&index=0&id=7d585794&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports